import React, { useState } from "react";
import { Button, Tooltip } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import NorthEast from "@mui/icons-material/NorthEast";
import SwapHoriz from "@mui/icons-material/SwapHoriz";
import Person from "@mui/icons-material/Person";
import Groups from "@mui/icons-material/Groups";
import { ImageBaseUrl } from "../../assets/utils/accessToken";
import ExecuteIcon from "../../GlobalComponents/IconComponents/ExcecuteIcon";
import ResolvedIcon from "../../GlobalComponents/IconComponents/ResolvedIcon";
import SuspendIcon from "../../GlobalComponents/IconComponents/SuspendIcon";
import { Colors } from "../../GlobalComponents/Utility/Colors";
import { array_status } from "../../ReduxTLK/features/SAV/ticketList";
import { canChangeTeam, getTeam } from "../../utils/escaladeUtils";
import NoteRate from "../../components/NoteRate/NoteRate";

import AddEscaladeModal from "./EditSAVTicketTabs/tabs/EscaladeTab/AddEscaladeModal";
import HeaderChangeTeamModal from "../Escalade/HeaderChangeTeamModal";
import HeaderCloseEscaladeModal from "../Escalade/HeaderCloseEscaladeModal";

import styles from "./EditSAVTicketHeader.module.css";
import ReassignModal from "./EditSAVTicketTabs/tabs/EscaladeTab/ReassignModal";

export default function EditSAVTicketHeader({
  ticketDetails,
  newTicket,
  canExecute,
  enCours,
  isEscaladed,
  activeInternalStatus,
  onExecuteOpen,
  onExecute,
  onSuspend,
  onResolve,
  onEscaladeRefresh,
  messagesList,
}) {
  const [openHeaderAdd, setOpenHeaderAdd] = useState(false);
  const [openHeaderChange, setOpenHeaderChange] = useState(false);
  const [openReassign, setOpenReassign] = useState(false);
  const [openHeaderClose, setOpenHeaderClose] = useState(false);

  const showHeaderChange =
    isEscaladed && canChangeTeam(activeInternalStatus?.type);
  const activeTeam = activeInternalStatus
    ? getTeam(activeInternalStatus.type)
    : null;

  const status = array_status.find((s) => s.id === ticketDetails?.statut);
  const logoImage = ticketDetails?.pointDeVente?.logo
    ? ImageBaseUrl + ticketDetails.pointDeVente.logo
    : null;
  const pageTitle = `#${ticketDetails?.id}`;
  const shopName = ticketDetails?.pointDeVente?.nom;
  const shopInitial = shopName ? shopName.charAt(0).toUpperCase() : "?";
  const subject = ticketDetails?.sujet
    ? ticketDetails.sujet.charAt(0).toUpperCase() +
    ticketDetails.sujet.toLowerCase().slice(1)
    : "";

  const lastMessage = messagesList?.length
    ? [...messagesList].sort((a, b) => new Date(b.date) - new Date(a.date))[0]
    : null;

  const ActionBtn = ({ icon, label, onClick, variant = "neutral" }) => (
    <Button
      onClick={onClick}
      startIcon={icon}
      className={`${styles.actionBtn} ${styles[`btn${variant.charAt(0).toUpperCase()}${variant.slice(1)}`]}`}
      disableRipple={false}
    >
      {label}
    </Button>
  );

  return (
    <>
      <div className={styles.card}>
        {/* Logo */}
        <div className={styles.logoWrap}>
          {logoImage != '' && logoImage != null ? (
            <img src={logoImage} alt="logo" className={styles.logoImg} />
          ) : (
            <div className={styles.logoPlaceholder}>{shopInitial}</div>
          )}
        </div>

        {/* Info */}
        <div className={styles.infoBlock}>
          <div className={styles.titleRow}>
            <h4 className={styles.ticketId}>{pageTitle}</h4>

            {status && (
              <span
                className={styles.statusChip}
                style={{ backgroundColor: status.backgroundColor }}
              >
                {status.nom}
              </span>
            )}

            {isEscaladed && activeTeam && (
              <span
                className={styles.escaladeBadge}
                style={{
                  borderColor: activeTeam.border,
                  backgroundColor: activeTeam.bg,
                  color: activeTeam.color,
                }}
              >
                <NorthEast sx={{ fontSize: 12 }} />
                Escalade · {activeTeam.label}
              </span>
            )}
          </div>

          <div className={styles.metaRow}>
            {shopName && (
              <span className={styles.shopName} title={shopName}>
                {shopName}
              </span>
            )}
            {shopName && subject && <span className={styles.dot} />}
            {subject && (
              <Tooltip title={subject} placement="top" arrow>
                <span className={styles.subject}>{subject}</span>
              </Tooltip>
            )}
          </div>
        </div>

        {/* Note / Rate */}
        <div className={styles.noteWrap}>
          <NoteRate rate={ticketDetails?.rate} lastMessage={lastMessage} />
        </div>

        {/* Actions */}
        <div className={styles.actions}>
          {(newTicket || canExecute) && (
            <ActionBtn
              icon={<ExecuteIcon color="#ffffff" />}
              label={newTicket ? "Exécuter" : "Relancer"}
              onClick={newTicket ? onExecuteOpen : onExecute}
              variant="primary"
            />
          )}

          {enCours && (
            <ActionBtn
              // user icon
              icon={<Person sx={{ fontSize: 16 }} />}
              label="Reassigner"
              onClick={() => setOpenReassign(true)}
              variant="neutral"
            />

          )}
          
          {enCours && isEscaladed && (
            <>

              {showHeaderChange && (
                <ActionBtn
                  icon={<Groups sx={{ fontSize: 16 }} />}
                  label="Changer"
                  onClick={() => setOpenHeaderChange(true)}
                  variant="neutral"
                />
              )}
              <ActionBtn
                icon={<CheckCircleIcon sx={{ fontSize: 16 }} />}
                label="Clôturer"
                onClick={() => setOpenHeaderClose(true)}
                variant="success"
              />
            </>
          )}

          {enCours && !isEscaladed && (
            <>
              <ActionBtn
                icon={<NorthEast sx={{ fontSize: 16 }} />}
                label="Escalader"
                onClick={() => setOpenHeaderAdd(true)}
                variant="neutral"
              />
              <ActionBtn
                icon={<SuspendIcon color={Colors.strongOrange} />}
                label="Attente"
                onClick={onSuspend}
                variant="warning"
              />
              <ActionBtn
                icon={<ResolvedIcon color={Colors.strongGreen} />}
                label="Résolu"
                onClick={onResolve}
                variant="success"
              />
            </>
          )}
        </div>
      </div>

      <ReassignModal
        open={openReassign}
        onClose={() => setOpenReassign(false)}
        ticketId={ticketDetails?.id}
        onSuccess={onEscaladeRefresh}
      />

      <AddEscaladeModal
        open={openHeaderAdd}
        onClose={() => setOpenHeaderAdd(false)}
        ticketId={ticketDetails?.id}
        onSuccess={onEscaladeRefresh}
      />


      <HeaderChangeTeamModal
        open={openHeaderChange}
        onClose={() => setOpenHeaderChange(false)}
        activeInternalStatus={activeInternalStatus}
        ticketId={ticketDetails?.id}
        onSuccess={onEscaladeRefresh}
      />

      <HeaderCloseEscaladeModal
        open={openHeaderClose}
        onClose={() => setOpenHeaderClose(false)}
        activeInternalStatus={activeInternalStatus}
        ticketId={ticketDetails?.id}
        onSuccess={onEscaladeRefresh}
      />
    </>
  );
}